import { mdiBookOpenVariant, mdiCodeBracesBox, mdiDatabaseOutline } from '@mdi/js';
import i18n from '@/i18n';

export default [
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.v2.title'),
      icon: mdiCodeBracesBox,
      requiresAuth: true,
      hideNewsletter: true,
      breadcrumbs: [{ label: i18n.global.t('menu_for_developers'), to: '/api-docs-auth' }],
    },
    path: '/api-docs-auth',
    name: 'api-docs-landing-auth',
    component: () => import('../../features/api-documentation/docs/DocsPageAuth.vue'),
  },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.storefront.routes.documentation'),
      icon: mdiCodeBracesBox,
      requiresAuth: false,
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs' },
        { label: i18n.global.t('page_titles.documentation'), to: '/api-docs/documentation' },
      ],
    },
    path: '/api-docs/documentation',
    name: 'api-docs-directory',
    component: () => import('../../features/api-documentation/docs/DocsPagePublic.vue'),
  },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.storefront.routes.documentation'),
      icon: mdiCodeBracesBox,
      requiresAuth: true,
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs-auth' },
        {
          label: i18n.global.t('page_titles.documentation'),
          to: '/api-docs-auth/documentation',
        },
      ],
    },
    path: '/api-docs-auth/documentation',
    name: 'api-docs-directory-auth',
    component: () => import('../../features/api-documentation/docs/DocsPageAuth.vue'),
  },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.storefront.routes.catalog'),
      icon: mdiDatabaseOutline,
      requiresAuth: false,
      requiresFeatureFlag: 'api-docs-catalog',
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs' },
        { label: i18n.global.t('api_docs.storefront.routes.catalog'), to: '/api-docs/catalog' },
      ],
    },
    path: '/api-docs/catalog',
    name: 'api-docs-catalog',
    component: () => import('../../features/api-store/pages/StorePublicPage.vue'),
  },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.storefront.routes.catalog'),
      icon: mdiDatabaseOutline,
      requiresAuth: false,
      requiresFeatureFlag: 'api-docs-catalog',
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs' },
        { label: i18n.global.t('api_docs.storefront.routes.catalog'), to: '/api-docs/catalog' },
      ],
    },
    path: '/api-docs/catalog/:datasetId',
    name: 'api-docs-catalog-dataset',
    component: () => import('../../features/api-store/pages/StoreDatasetPublicPage.vue'),
  },
  // The signed-in catalogue, the cart page and the quote receipt became the
  // API store (/api/store) and its cart drawer; old links keep working.
  { path: '/api-docs-auth/catalog', name: 'api-docs-catalog-auth', redirect: '/api/store' },
  {
    path: '/api-docs/catalog/cart',
    name: 'api-docs-cart',
    redirect: { path: '/api-docs/catalog', query: { cart: 'open' } },
  },
  {
    path: '/api-docs-auth/catalog/cart',
    name: 'api-docs-cart-auth',
    redirect: { path: '/api/store', query: { cart: 'open' } },
  },
  { path: '/api-docs/catalog/cart/success', name: 'api-docs-cart-success', redirect: '/api-docs/catalog' },
  { path: '/api-docs-auth/catalog/cart/success', name: 'api-docs-cart-success-auth', redirect: '/api/store' },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.v2.title'),
      icon: mdiBookOpenVariant,
      requiresAuth: false,
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs/documentation' },
        { label: i18n.global.t('page_titles.documentation'), to: '/api-docs/:datasetId' },
      ],
    },
    path: '/api-docs/:datasetId',
    name: 'api-docs',
    component: () => import('../../features/api-documentation/docs/DocsPagePublic.vue'),
  },
  {
    meta: {
      cauldron: 'api',
      title: i18n.global.t('api_docs.v2.title'),
      icon: mdiBookOpenVariant,
      requiresAuth: true,
      hideNewsletter: true,
      breadcrumbs: [
        { label: i18n.global.t('menu_for_developers'), to: '/api-docs-auth/documentation' },
        { label: i18n.global.t('page_titles.documentation'), to: '/api-docs-auth/:datasetId' },
      ],
    },
    path: '/api-docs-auth/:datasetId',
    name: 'api-docs-auth',
    component: () => import('../../features/api-documentation/docs/DocsPageAuth.vue'),
  },
];
